import { ShowMoreArtsButtonController } from './show-more-arts-button.controller'

function showMoreArtsButton () {
  return {
    restrict: 'E',
    controller: ShowMoreArtsButtonController,
    templateUrl: '/arts/directives/show-more-arts-button/show-more-arts-button.html?$$REVISION$$',
    scope: {
      handleOnClick: '&',
      isLoading: '='
    }
  }
}

export { showMoreArtsButton }
